/**
 * The abort reason a presentation run gives when it ends because it finished,
 * rather than because it was stopped, cancelled or failed.
 *
 * Its own module so the controller can name it without loading the speech
 * engine: speech that plays alongside an action outlives its run, and has to
 * tell a finish from a Stop to know whether to fall silent.
 */
export const PRESENTATION_FINISHED = "presentation_finished";
